import { z } from 'zod';

// Validação de envs do Vite (VITE_*). Falha cedo no boot se algo estiver errado.
const envSchema = z.object({
  VITE_API_BASE: z.string().default(''),
});

export const env = envSchema.parse({
  VITE_API_BASE: import.meta.env.VITE_API_BASE,
});
